import { createContext, PropsWithChildren } from 'react';

/** `addonsKey` labels a line-item toolbar. NOT the `gridKey` editing bucket. */
const GridAddonsContext = createContext<{
  handleAddLineItem?: (args?: unknown) => void;
  showButton?: boolean;
  addonsKey: string;
}>(undefined);

export default function GridAddonsContextProvider({
  children,
  handleAddLineItem,
  showButton,
  addonsKey,
}: PropsWithChildren<{ handleAddLineItem?: (args?: unknown) => void; showButton?: boolean; addonsKey: string }>) {
  return (
    <GridAddonsContext.Provider value={{ handleAddLineItem, showButton, addonsKey }}>
      {children}
    </GridAddonsContext.Provider>
  );
}
